export const regionsOptions = [
    { label: 'Europe', value: 'eu' },
    { label: 'United States', value: 'us' },
    { label: 'China', value: 'cn' },
    { label: 'Canada', value: 'ca' },
    { label: 'Japan', value: 'jp' },
    { label: 'Australia', value: 'au' },
];